var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[_c('dx-button',{attrs:{"text":_vm.i18n.t('authentication-basic.logout.button')},on:{"click":_vm.onButtonClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }